module.exports = __webpack_public_path__ + "static/media/blue-sponge.2bd84a50.jpg";